import { SET_FLOW } from '../types';
import { invalidateFlowVariables } from './flowVariables';

export const setFlow = (data) => (dispatch) => {
  dispatch({
    type: SET_FLOW,
    payload: data,
  });
  dispatch(invalidateFlowVariables(data?.id ?? null));
};
